import LeftNav from '@/pages/left-nav';
import './style.less';
import { useEffect } from 'react';
import { reloadTables } from '@/state/db';

export default function Layout() {
  useEffect(() => {
    reloadTables();
  }, []);

  return (
    <div className="left-nav">
      <LeftNav />
    </div>
  );
}
